import { render, staticRenderFns } from "./DetailMarketplace.vue?vue&type=template&id=55030366&"
import script from "./DetailMarketplace.vue?vue&type=script&lang=js&"
export * from "./DetailMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports